import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed, watch } from "vue";
  import { useStore } from "vuex";
  import { POSITION, useToast } from "vue-toastification";
  import ChartForReports from "@/components/reports/ChartForReports.vue";
  import { BuyerTypes } from "@/enums/BuyerTypes";
  import { ChartsTypes } from "@/enums/ChartsTypes";
  import { AnalyticsBuyerTypeInterface } from "@/types/AnalyticsBuyerTypeInterface";
  import {
    backgroundColorForBuyerType,
    optionsPieChart,
  } from "@/constants/optionsChart";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuyerType',
  props: {
    startDate: {
      type: String,
      required: true,
    },
    endDate: {
      type: String,
      required: true,
    },
    searchKey: {
      type: Number,
      required: true,
    },
    estateSelected: {
      type: String,
      required: true,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

  const store = useStore();
  const toast = useToast();
  const loading = ref(false);
  const buyerType = ref<AnalyticsBuyerTypeInterface[]>([]);

  const landownerId = computed(() => store.state.user.data._id);

  const startDateSelected = computed(() => {
    return props.startDate;
  });

  const endDateSelected = computed(() => {
    return props.endDate;
  });

  const estateSelected = computed(() => {
    return props.estateSelected;
  });

  watch(
    () => props.searchKey,
    () => {
      getBuyerTypes();
    }
  );

  const getBuyerTypes = async () => {
    loading.value = true;

    if (landownerId.value) {
      store
        .dispatch("analytics/getBuyerTypes", {
          landownerId: landownerId.value,
          startDate: startDateSelected.value,
          endDate: endDateSelected.value,
          estateSelected: estateSelected.value,
        })
        .then((res) => {
          buyerType.value = res.data;
        })
        .catch((err) => {
          toast.error("Error getting buyer types", {
            position: POSITION.TOP_LEFT,
          });
        })
        .finally(() => {
          loading.value = false;
        });
    }
  };

  const buyerTypeSummary = computed(() => {
    const summary = buyerType.value.map((buyerType) => {
      return {
        estate: buyerType.estate,
        buyerTypes: [BuyerTypes.OWNER_OCCUPIER, BuyerTypes.INVESTOR],
        counts: [buyerType.ownerOccupier.count, buyerType.investor.count],
        percentages: [
          buyerType.ownerOccupier.percentage,
          buyerType.investor.percentage,
        ],
      };
    });

    return summary;
  });

  const shouldRenderCharts = computed(() => {
    return buyerTypeSummary.value.some((estateData) => {
      return (
        estateData.percentages.some((value) => value !== 0) ||
        estateData.counts.some((value) => value !== 0)
      );
    });
  });

  const shouldRenderPieChartPercentages = computed(() => {
    return buyerTypeSummary.value.some((estateData) => {
      return estateData.percentages.some((value) => value !== 0);
    });
  });

  const shouldRenderPieChartCounts = computed(() => {
    return buyerTypeSummary.value.some((estateData) => {
      return estateData.counts.some((value) => value !== 0);
    });
  });

  const areAllCountsZero = (counts: number[] = []): boolean => {
    return counts.every((count) => count === 0);
  };

  onMounted(() => {
    getBuyerTypes();
  });

const __returned__ = { props, store, toast, loading, buyerType, landownerId, startDateSelected, endDateSelected, estateSelected, getBuyerTypes, buyerTypeSummary, shouldRenderCharts, shouldRenderPieChartPercentages, shouldRenderPieChartCounts, areAllCountsZero, ref, onMounted, computed, watch, get useStore() { return useStore }, get POSITION() { return POSITION }, get useToast() { return useToast }, ChartForReports, get BuyerTypes() { return BuyerTypes }, get ChartsTypes() { return ChartsTypes }, get AnalyticsBuyerTypeInterface() { return AnalyticsBuyerTypeInterface }, get backgroundColorForBuyerType() { return backgroundColorForBuyerType }, get optionsPieChart() { return optionsPieChart } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})